import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-22d1a9ed")
const _hoisted_1 = { class: "ml-[16px]" }
const _hoisted_2 = { class: "text-secondary mb-[4px] flex text-sm font-medium" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 0,
  class: "funds flex items-center truncate text-xl font-medium"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "funds flex items-center truncate text-xl font-medium"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "pool-invest w-full text-center"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Invest in the pool and earn on swap fees! ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "Invest in the pool", -1)
const _hoisted_11 = { class: "card-container flex flex-1" }
const _hoisted_12 = { class: "ml-[16px]" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-secondary mb-[4px] flex text-sm font-medium" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Your total value in $")
], -1)
const _hoisted_14 = { class: "funds flex items-center truncate text-xl font-medium" }
const _hoisted_15 = { class: "card-container flex flex-1" }
const _hoisted_16 = { class: "ml-[16px]" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text-secondary mb-[4px] flex text-sm font-medium" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Your reward in $")
], -1)
const _hoisted_18 = { class: "funds claim flex items-center truncate text-xl font-medium" }
const _hoisted_19 = {
  key: 0,
  class: "pool-invest flex-1"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Invest in the pool and earn on swap fees! ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "Invest in the pool", -1)
const _hoisted_22 = { class: "pool-invest flex-1" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" You can claim in any time ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "Claim reward", -1)
const _hoisted_25 = { class: "pool-invest flex-1" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" View more details about investment ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "View dashboard", -1)
_popScopeId()

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import APRTooltip from '@/components/tooltips/APRTooltip/APRTooltip.vue';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import { totalAprLabel } from '@/composables/usePool';
import { APR_THRESHOLD } from '@/constants/pools';
import { Pool, PoolAPRs } from '@/services/pool/types';
import ArrowDownIcon2 from '@/components/_global/icons/ArrowDownIcon2.vue';
import MyPoolInvsetmentFiat, {
  MyPollInvestmentFiatType,
} from '@/components/pool/MyPoolInvsetmentFiat.vue';
import useStake from '@/composables/PolarisFinance/useStake';
import { BigNumber } from 'ethers';
import { TransactionResponse } from '@ethersproject/providers';
import useWeb3 from '@/services/web3/useWeb3';
import useTransactions from '@/composables/useTransactions';
import useEthers from '@/composables/useEthers'
import useBreakpoints from '@/composables/useBreakpoints';

/**
 * TYPES
 */
type Props = {
  pool: Pool;
  poolApr: PoolAPRs;
  loading?: boolean;
  loadingApr?: boolean;
  aprString: string;
  stakedBalance: string;
  xpolarPrice: string;
  xpolarToClaim: string;
};


/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    poolApr: { type: null, required: true },
    loading: { type: Boolean, required: false, default: false },
    loadingApr: { type: Boolean, required: false },
    aprString: { type: String, required: true },
    stakedBalance: { type: String, required: true },
    xpolarPrice: { type: String, required: true },
    xpolarToClaim: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: Pool;
  poolApr: PoolAPRs;
  loading?: boolean;
  loadingApr?: boolean;
  aprString: string;
  stakedBalance: string;
  xpolarPrice: string;
  xpolarToClaim: string;
}) {

const props = __props


/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const { t } = useI18n();
const { isMobile, isDesktop } = useBreakpoints();
/**
 * COMPUTED
 */
const aprLabel = computed((): string => {
  const poolAPRs = props.poolApr;
  if (!poolAPRs) return '0';

  return totalAprLabel(poolAPRs, props.pool.boost);
});
const stakedBalance = computed(() => {
  return props.stakedBalance;
});
const rewardFiat = computed(() => {
  return fNum2(
    Number(props.xpolarPrice) * Number(props.xpolarToClaim),
    FNumFormats.fiat
  );
});

const { account } = useWeb3();


const stats = computed(() => {
  if (!props.pool) return [];

  let outStats = [
    {
      id: 'poolValue',
      label: t('poolValue'),
      value: fNum2(props.pool.totalLiquidity, FNumFormats.fiat),
      loading: props.loading,
    },
    {
      id: 'apr',
      label: 'APR',
      value:
        Number(props.poolApr?.total.unstaked || '0') * 100 > APR_THRESHOLD
          ? '-'
          : aprLabel.value,
      loading: props.loadingApr,
    },
  ];

  if (props.stakedBalance == '0') {
    outStats.splice(1, 0, {
      id: 'volumeTime',
      label: t('volumeTime', ['24h']),
      value: fNum2(props.pool.volumeSnapshot || '0', FNumFormats.fiat),
      loading: props.loading,
    });
    outStats.splice(1, 0, {
      id: 'feesTime',
      label: t('feesTime', ['24h']),
      value: fNum2(props.pool.feesSnapshot || '0', FNumFormats.fiat),
      loading: props.loading,
    });
  }

  return outStats;
});
const { addTransaction } = useTransactions();
const txHandler = (tx: TransactionResponse): void => {
  addTransaction({
    id: tx.hash,
    type: 'tx',
    action: 'approve',
    summary: 'approve for staking',
  });
};
const { txListener } = useEthers();
const { getProvider } = useWeb3();
async function claimXpolar(address) {
  const { withdraw } = useStake();
  const tx = await withdraw(address, BigNumber.from(0), getProvider());
  txHandler(tx);
  txListener(tx, {
    onTxConfirmed: () => {
      
    },
    onTxFailed: () => {},
  });
}

return (_ctx: any,_cache: any) => {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")!
  const _component_WalletNewIcon = _resolveComponent("WalletNewIcon")!
  const _component_VolumeTimeIcon = _resolveComponent("VolumeTimeIcon")!
  const _component_DollarCoinsStackedIcon = _resolveComponent("DollarCoinsStackedIcon")!
  const _component_AprIcon = _resolveComponent("AprIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DollarCircledIcon = _resolveComponent("DollarCircledIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex w-full", {'flex-wrap':_unref(isMobile),'mb-[24px]':_unref(isDesktop)}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stats), (stat) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: stat.id
        }, [
          (stat.loading)
            ? (_openBlock(), _createBlock(_component_BalLoadingBlock, {
                key: 0,
                class: "h-24"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["card-container flex flex-1", {'justify-center':_unref(isDesktop),'justify-start mb-10':_unref(isMobile)}])
              }, [
                _createElementVNode("div", null, [
                  (stat.id == 'poolValue')
                    ? (_openBlock(), _createBlock(_component_WalletNewIcon, { key: 0 }))
                    : _createCommentVNode("", true),
                  (stat.id == 'volumeTime')
                    ? (_openBlock(), _createBlock(_component_VolumeTimeIcon, { key: 1 }))
                    : _createCommentVNode("", true),
                  (stat.id == 'feesTime')
                    ? (_openBlock(), _createBlock(_component_DollarCoinsStackedIcon, { key: 2 }))
                    : _createCommentVNode("", true),
                  (stat.id == 'apr')
                    ? (_openBlock(), _createBlock(_component_AprIcon, { key: 3 }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(stat.label), 1)
                  ]),
                  (stat.label != 'APR')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createTextVNode(_toDisplayString(stat.value) + " ", 1),
                        (stat.label == 'APR')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_5, "%"))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createTextVNode(_toDisplayString(__props.aprString) + " ", 1),
                        (stat.label == 'APR')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "%"))
                          : _createCommentVNode("", true)
                      ]))
                ])
              ], 2))
        ], 64))
      }), 128)),
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_router_link, {
              class: "invest-btn flex w-full items-center",
              to: '/pool/' + __props.pool?.id + '/invest'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PlusIcon, { class: "ml-3 flex-none" }),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_unref(account) && Number(_unref(stakedBalance)) > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["card-container flex flex-1", {'my-8':_unref(isMobile)}])
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createVNode(_component_DollarCircledIcon)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(MyPoolInvsetmentFiat, {
                      pool: __props.pool,
                      tokens: Number(_unref(stakedBalance))
                    }, null, 8, ["pool", "tokens"])
                  ])
                ])
              ])
            ], 2),
            (_unref(account) && Number(_unref(stakedBalance)) > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["card-container flex flex-1", {'my-8':_unref(isMobile)}])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, [
                      _createVNode(_component_DollarCoinsStackedIcon)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(rewardFiat)), 1)
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["buttons-panel flex text-center", {'flex-wrap':_unref(isMobile)}])
    }, [
      (_unref(isDesktop))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _createVNode(_component_router_link, {
              class: "invest-btn flex w-full items-center",
              to: '/pool/' + __props.pool?.id + '/invest'
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PlusIcon, { class: "ml-3 flex-none" }),
                _hoisted_21
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true),
      (_unref(account) && Number(_unref(stakedBalance)) > 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["my-panel flex flex-1 gap-4", {'l-border pl-[24px]':_unref(isDesktop),'flex-col':_unref(isMobile)}])
          }, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("button", {
                class: "invest-btn block flex w-full items-center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (claimXpolar(__props.pool.address)))
              }, [
                _hoisted_24,
                _createVNode(_component_ArrowRightIcon, { class: "ml-3 flex-none" })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_router_link, {
                class: "goto-btn flex w-full items-center",
                to: '#dashboard'
              }, {
                default: _withCtx(() => [
                  _hoisted_27,
                  _createVNode(ArrowDownIcon2, { class: "ml-3 flex-none" })
                ]),
                _: 1
              })
            ])
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})